import { Box, Button, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

import { ReactComponent as AsteriskIcon } from '@work4all/assets/icons/asterisk.svg';

import { usePasswordChangeDialog } from '../../../../../../../../components/user-menu/components/PasswordChangeDialog/use-password-change-dialog';
import { useFormContextPlus } from '../../../../../../form-plus/use-form-context-plus';
import { UserFormValue } from '../../../types';

export const ChangePasswordContent = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { getValues } = useFormContextPlus<UserFormValue>();

  const id = getValues('id');
  const displayName = getValues('displayName');

  const openPasswordDialog = usePasswordChangeDialog({
    userId: id,
    hideOldPassword: true,
    hideLoggingOutWarning: true,
  });

  const handleChangePassword = async () => {
    const passwordChanged = await openPasswordDialog();

    if (passwordChanged) {
      enqueueSnackbar(t('ALERTS.PASSWORD_CHANGED'), {
        variant: 'success',
        autoHideDuration: 3000,
      });
    }
  };

  return (
    <Box>
      <Typography whiteSpace="pre-line">
        {t('SECURITY_TAB_PANEL.CHANGE_PASSWORD', {
          displayName,
        })}
      </Typography>

      <Button onClick={handleChangePassword} startIcon={<AsteriskIcon />}>
        {t('SECURITY_TAB_PANEL.SET_NEW_PASSWORD')}
      </Button>
    </Box>
  );
};
